export function toSeconds ({ v, suffix, }) {
    switch (suffix) {
    case 'm': return v * 60
    case 'h': return v * 3600
    default: return v
    }
}
